<template >
  <v-footer class="footer" dark  absolute padless>
    <v-card flat tile width="100%" class="footercolor white--text text-center">
      <v-card-text>
      </v-card-text>
      <v-card-text
        class="white--text pt-0 d-flex"
      >
        <div style="width: 100%">
          <div style="flex: 2">
            <div class="list">
              <div class="li" @click="$router.push('/contact-us')">Contact Us</div>
              <div class="li" @click="$router.push('/faqs')">FAQs</div>
              <div class="li" @click="$router.push('/privacy-policy')">Privacy Policy</div>
              <div class="li" @click="$router.push('/terms-and-conditions')">Terms & Conditions</div>
            <div class ="li">
              <b-link href="https://play.google.com/store/apps/details." target="_blank" >
           <v-img class = "mx-auto" style="width:150px; cursor: pointer;" src="/img/google-play-badge.png" />
              </b-link>
            </div>
            </div>
          </div>
          <div style="text-align: center; width: 100%">
            © 2020 INTISAI. All Rights Reserved. 
            All related channel and programming logos are service marks of INTISAI,<br />
            and all related programming visuals and the services offered and elements are the property of INTISAI.
          </div>
          
        </div>
      </v-card-text>
    </v-card>
  </v-footer>
</template>
<script>
export default {
  }
</script>
<style scoped>
  .list {
    margin-left: 90px;
    text-align: left;
    font-weight: 800;
    list-style: none;
    display: flex;
    margin-bottom: 10px;
  }
  .list .li {
    flex: 1;
    cursor: pointer;
    margin-bottom: 10px;
    transition: all 0.3s ease;
    display: inline-block;
    min-width: 200px;
  }
  .list .li:hover {
    transform: translateX(10px);
  }
</style>
<style >
.v-application .footercolor{
  background-image: linear-gradient( 159.6deg,  rgb(140, 177, 207) 11.2%, rgb(54, 129, 167) 100.2% );
  
  padding-bottom: 10px;
}
</style>